/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import PropTypes from 'prop-types'; // eslint-disable-line no-unused-vars
import fileSize from 'filesize';
import Modal from '../modal/Modal';

import styles from './ChecklistSuccessfullyGeneratedPdfModal.module.scss';

ChecklistSuccessfullyGeneratedPdfModal.propTypes = {
    handleCloseOnClick: PropTypes.func.isRequired,
    timeElapsed: PropTypes.number,
    checklists: PropTypes.array,
};

export default function ChecklistSuccessfullyGeneratedPdfModal(props) {
    return (
        <Modal
            contentLabel='quote-export-modal'
            onCloseClick={props.handleCloseOnClick}
            header={
                <div>
                    <div>Checklist PDF(s) Successfully Created</div>
                    <div
                        style={{
                            fontSize: 14,
                            fontStyle: 'italic',
                            paddingTop: 5,
                            fontWeight: 'normal',
                        }}
                    >
                        <span className={styles.createdTime}>
                            created in <b>{props.timeElapsed}</b> seconds
                        </span>
                    </div>
                </div>
            }
            showClose
        >
            <div>
                <p>Click each to download:</p>
                {props.checklists.map(c => (
                    <div className={styles.linkContainer}>
                        <a href={c.exportLink} target='blank'>
                            <i className='fa fa-file-pdf-o fa-2x' />
                            <span className={styles.linkText}>{c.name}</span>
                        </a>
                        {c.fileSize && (
                            <div
                                className={
                                    c.fileSize >= 15000000
                                        ? styles.fileSizeTextWarn
                                        : null
                                }
                            >
                                {fileSize(c.fileSize, { base: 10 })}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </Modal>
    );
}
